import {useCallback} from "react";
import {postAddKey} from "../api";
import {AdminAction} from "../types";
import {useToast} from "use-toast-mui";

export const useAddKey = () => {
    const toast = useToast();

    const addKey: AdminAction = useCallback(async (activationKey: string): Promise<void> => {
        try {
            await postAddKey(activationKey);
        } catch (error) {
            toast.error("Something went wrong when adding a key.");
        }
    }, [toast])

    return {addKey}
}
